const Fonts = {
    Roboto:{
        black: require('./Roboto/Roboto-Black.ttf'),
        bold: require('./Roboto/Roboto-Bold.ttf'),
        regular: require('./Roboto/Roboto-Regular.ttf')
    }
};

export default Fonts;